import React from "react";
import {connect} from "react-redux";
import {openModal} from "../../actions/modal";


class Video extends React.Component {

    render() {

        const {videoId, openModal} = this.props;
        return (
          <section className={"rob-video__fullwidth"} data-video={videoId}
                   style={{backgroundImage: `url(https://img.youtube.com/vi/${videoId}/maxresdefault.jpg)`}}>
              <button onClick={() => openModal('video', videoId)} className="rob-video__trigger">
                  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80">
                      <g fill="none" fillRule="evenodd">
                          <circle cx="40" cy="40" r="40" fill="#f7b733"/>
                          <path fill="#FFF" d="M33.6 31.2l16 8.87-16 8.73z"/>
                      </g>
                  </svg>
              </button>
          </section>
        )
    }
}

function mapStateToProps(state) {
    return {

    };
}
export default connect(mapStateToProps, {openModal})(Video);




// WEBPACK FOOTER //
// ./src/components/elements/Video.js